import { useState } from "react";

const faqs = [
  {
    q: "校园爆笑社的内容来源是真实的吗？",
    a: "站内趣事大多来自网友的真实校园投稿与投稿人自述，在发布前会隐去真实姓名与学校信息，仅供娱乐分享。为阅读体验，部分细节会做艺术加工。",
  },
  {
    q: "我该怎么投稿自己的校园趣事？",
    a: "点击页面顶部的「立即投稿」，填写事件分类、标题、你的邮箱和事件描述，审核通过后就会以匿名的形式在对应专区上架，被选中的作者还有机会登上本期「爆笑之星」。",
  },
  {
    q: "宿舍与课堂的爆料会暴露身份吗？",
    a: "不会。我们会对投稿做二次加工，替换姓名、化名处理并隐去学校细节，只保留搞笑的重点，让主角们都能安心吃自己的瓜。",
  },
  {
    q: "被写进爆料觉得冒犯怎么办？",
    a: "可以通过投稿表单备注或页脚邮箱联系小编，说明对应内容。只要是真实事件相关方提出异议，我们会第一时间下架该内容并向你致歉。",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-900">
            <i className="ri-questionnaire-line" /> FAQ
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-900 md:text-4xl">
            关于吃瓜与爆料
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            关于内容真实性、投稿方式和隐私保护，这里都有答案。玩梗有度，吃瓜也要讲礼貌，我们坚持「笑点可以有，伤害不能有」。
          </p>
          <div className="mt-5 hidden rounded-2xl border border-background-200 bg-background-50 p-5 lg:block">
            <div className="flex items-center gap-3">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-accent-100 text-2xl">
                🫶
              </span>
              <div>
                <p className="font-heading text-base text-foreground-900">友善吃瓜公约</p>
                <p className="text-xs text-foreground-500">不造谣 · 不人肉 · 不恶搞真人真实姓名</p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-3 lg:col-span-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 p-4 text-left md:p-5"
                >
                  <h3 className="flex items-center gap-3 font-heading text-base text-foreground-900 md:text-lg">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold ${
                        isOpen ? "bg-primary-500 text-white" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      Q{i + 1}
                    </span>
                    {f.q}
                  </h3>
                  <i
                    className={`shrink-0 text-xl text-foreground-400 transition-transform ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  >
                    {isOpen ? "ri-close-line" : "ri-add-line"}
                  </i>
                </button>
                {isOpen && (
                  <p className="border-t border-dashed border-background-200 px-5 py-4 pl-16 text-sm leading-relaxed text-foreground-600 md:px-5 md:pl-[60px]">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}